import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COUNTRY_FEATURE_KEY, countryAdapter, CountryState } from './country.reducer';

// Lookup the 'Country' feature state managed by NgRx
export const getCountryState = createFeatureSelector<CountryState>(COUNTRY_FEATURE_KEY);

const { selectAll, selectEntities } = countryAdapter.getSelectors();

export const getCountryLoaded = createSelector(getCountryState, (state: CountryState) => state.loaded);

export const getCountryError = createSelector(getCountryState, (state: CountryState) => state.error);

export const getAllCountry = createSelector(getCountryState, (state: CountryState) => selectAll(state));

export const getCountryEntities = createSelector(getCountryState, (state: CountryState) => selectEntities(state));

export const getSingaporeCountry = createSelector(getCountryState, (state: CountryState) =>
  selectAll(state).find(country => country.alpha2 === 'SG'),
);
